<div class="py-2 w-full bg-white sticky top-0 z-10 flex justify-center items-center md:hidden">
  <button
    class="text-white text-sm rounded-full py-2 px-2 h-[40px] w-[150px]"
    [ngClass]="
      brand.isLexus()
      ? 'bg-lexusBlue hover:bg-lexusBlueDark'
      : 'bg-toyotaRed hover:bg-toyotaRedDark'
      "
    (click)="nextStep.emit()"
  >
    Weiter
  </button>
</div>

<div class="flex flex-col justify-center items-center">
  <div
    class="flex w-full items-center flex-col md:flex-row md:justify-between md:sticky md:top-0 md:z-10 py-2 md:bg-white"
  >
    <div class="hidden md:block w-[150px] md:order-first"></div>
    <span class="text-center lg:text-lg font-semibold order-last">
        Allgemeine Informationen zu Ihrer Einwilligung
      </span>
    <button
      class="hidden md:block md:order-last text-white text-sm rounded-full py-2 px-2 h-[40px] w-[150px]"
      [ngClass]="
        brand.isLexus()
        ? 'bg-lexusBlue hover:bg-lexusBlueDark'
        : 'bg-toyotaRed hover:bg-toyotaRedDark'
        "
      (click)="nextStep.emit()"
    >
      Weiter
    </button>
  </div>

  <!-- IHRE DATEN -->
  <div class="flex flex-col md:flex-row gap-2 text-sm border-2 border-lighterText mx-2 mt-2 mb-2 rounded-2xl py-2 px-4 w-full">
    <div class="flex gap-2 w-full md:w-[60%]">
      <div class="w-[60%] md:w-[45%] flex flex-col">
        <span class="font-semibold underline text-base mb-2">IHRE DATEN</span>
        <span>{{ customerWizardResponse.companyname }}</span>
        <span>{{ customerWizardResponse.firstName }} {{ customerWizardResponse.lastName }}</span>
        <span>{{ customerWizardResponse.primaryAddress.street }}</span>
        <span>{{ customerWizardResponse.primaryAddress.postcode }} {{ customerWizardResponse.primaryAddress.city }}</span>
      </div>
      <div
        class="w-[40%] md:w-[55%] flex flex-col"
        [ngStyle]="{'margin-top': getVisibleContactLines(customerWizardResponse).length < 5 ? '30px' : '4px'}"
      >
        @if (customerWizardResponse.emailPersonal) {
          <span class="break-words">{{ customerWizardResponse.emailPersonal }}</span>
        }
        @if (customerWizardResponse.emailOffice) {
          <span class="break-words">{{ customerWizardResponse.emailOffice }}</span>
        }
        @if (customerWizardResponse.phoneMobile) {
          <span>{{ customerWizardResponse.phoneMobile }}</span>
        }
        @if (customerWizardResponse.phoneHome) {
          <span>{{ customerWizardResponse.phoneHome }}</span>
        }
        @if (customerWizardResponse.phoneOffice) {
          <span>{{ customerWizardResponse.phoneOffice }}</span>
        }
      </div>
    </div>
    <div class="w-full md:w-[40%]">
      <span>
        Sonstige im Zusammenhang mit der Kundenbeziehung mit den unten genannten Verantwortlichen angegebenen
        bzw. erhobenen Daten (weitere Kontaktdaten, Geburtsdatum, Kfz-Kennzeichen,
        Fahrzeug-Identifizierungsnummer(FIN), Fahrzeugdaten, Vertragskonditionen,Rechnungsdaten,
        Servicetermine, etc.). Weitere Informationen hierzu entnehmen Sie bitte der Datenschutzinformation.
      </span>
    </div>
  </div>

  <!-- VERANTWORTLICHE -->
  <div class="flex flex-col text-sm border-2 border-lighterText mx-2 my-2 rounded-2xl py-2 px-4 w-full">
    <span class="font-semibold underline text-base mb-2">
      VERANTWORTLICHE ("WIR" / "{{ brand.brandName().toUpperCase() }}")
    </span>
    <div class="flex flex-col md:flex-row gap-2 md:gap-6 w-full">
      <div class="flex flex-col md:w-[29%]">
        <span>Toyota {{ legalEntity.country.isAustria ? 'Austria' : 'Deutschland' }} GmbH</span>
        <span>Toyota Motor Europe NV/SA</span>
      </div>
      <div class="flex flex-col md:w-[71%]">
        @if (customerWizardResponse.dealer.dealerNumber === 'TOYOTA') {
          <span>{{ legalEntity.name }}</span>
        } @else {
          <span>{{ customerWizardResponse.dealer.fullCompanyName }}</span>
        }
        <span>Weitere {{ brand.brandName() }}-Vertragspartner, denen Sie bereits eine Einwilligung gegeben haben.</span>
      </div>
    </div>
  </div>

  <div class="flex flex-col md:flex-row md:gap-6 w-full">
    <div class="flex flex-col w-full md:w-1/2 text-sm border-2 border-lighterText my-2 rounded-2xl py-2 px-4">
      <!-- WIDERRUFSHINWEIS -->
      <span class="font-semibold underline text-base mb-2">WIDERRUFSHINWEIS</span>
      <span>
        Sie können Ihre Einwilligung(en) jederzeit mit Wirkung für die Zukunft widerrufen. Ihren Widerruf können
        Sie gegenüber jedem o.g. Verantwortlichen erklären, indem Sie sich an die zentrale Einwilligungsverwaltung wenden:
      </span>
      <span>{{ brand.brandName() }} Kundenbetreuung, {{ legalEntity.country.countryId === 'AT' ? 'Wienerbergstraße ' +
        '11, Turm A, 23. OG, ' : ''}} {{ legalEntity.city }},
        <a [href]="'mailto:' + legalEntity.email" class="cursor-pointer underline">{{legalEntity.email}}</a>
        oder
        <a [href]="'tel:' + legalEntity.phone" class="cursor-pointer underline">{{ legalEntity.phone }}</a>
      </span>
      <span class="mt-2">
        Darüber hinaus steht Ihnen das {{ brand.brandName() }} Einwilligungscenter zur Verfügung, in dem Sie Ihre Einwilligungen
        auch selbst verwalten können.
      </span>
    </div>

    <!-- DATENSCHUTZINFORMATION -->
    <div class="flex flex-col w-full md:w-1/2 text-sm border-2 border-lighterText my-2 rounded-2xl py-2 px-4">
      <span class="font-semibold underline text-base mb-2">DATENSCHUTZINFORMATION</span>
      <span>
        Detaillierte Datenschutzinformationen zur Verarbeitung Ihrer personenbezogenen Daten erhalten Sie
        vor Ort im Autohaus sowie unter diesem Link:
      </span>
      <span>
        @if(customerWizardResponse.dealer.dealerNumber === 'TOYOTA') {
          <a
            [href]="'https://service.tcc.toyota.itsd-consulting.services/toyota/dsi/' +
            customerWizardResponse.currentConsentVersion + '/pdf'"
            target="_blank"
            class="cursor-pointer underline"
          >
            https://service.tcc.toyota.itsd-consulting.services/toyota/dsi/{{ customerWizardResponse.currentConsentVersion }}/pdf
          </a>
        } @else {
          <a
            [href]="'https://service.tcc.toyota.itsd-consulting.services/toyota/dsi/' +
            customerWizardResponse.currentConsentVersion + '/' +
            customerWizardResponse.dealer.dealerNumber + '/pdf'"
            target="_blank"
            class="cursor-pointer underline"
          >
            https://service.tcc.toyota.itsd-consulting.services/toyota/dsi/{{ customerWizardResponse.currentConsentVersion }}/{{ customerWizardResponse.dealer.dealerNumber }}/pdf
          </a>
        }
      </span>
    </div>
  </div>
</div>
